export default __webpack_public_path__ + "static/media/resetPassword.a2fc86f8.svg";